var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAmericanExpress = function SvgAmericanExpress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "american-express_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".american-express_svg__st1,.american-express_svg__st2{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.american-express_svg__st2{fill:#296bb4}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e6cb3"
    },
    d: "M0 0h40v40H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "american-express_svg__st1",
    d: "M14.2 33.7V19.2H40v4l-3 3.2 3 3.2v4.1h-4.7l-2.6-2.8-2.5 2.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "american-express_svg__st2",
    d: "M15.9 32.1V20.8h9.6v2.6H19v1.7h6.4v2.6H19v1.7h6.5v2.7zM25.5 32.1l5.3-5.7-5.3-5.6h4.1l3.2 3.5 3.3-3.5H40l-5.2 5.6 5.2 5.5v.2h-4l-3.3-3.6-3.2 3.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "american-express_svg__st1",
    d: "M15.4 6.3h6.2l2.2 4.9V6.3h7.7l1.3 3.7 1.4-3.7H40v14.5H9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "american-express_svg__st2",
    d: "m16.6 7.9-5 11.3H15l.9-2.3H21l.9 2.3h3.5l-5-11.3h-3.8zm.4 6.5 1.5-3.6 1.5 3.6h-3zM25.5 19.2V7.9h4.9l2.5 6.9 2.5-6.9H40v11.3h-3v-7.8l-2.8 7.8h-2.7l-2.9-7.8v7.8z"
  })));
};
export default SvgAmericanExpress;